var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"loading-spinner-container"},[_c('img',{staticClass:"loading-spinner-gcmcn",attrs:{"src":require("../../../../static/img/loading_spinner.png")}}),_vm._v(" "),_c('div',{staticClass:"loading-text-gcmcn"},[_vm._v("loading")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60dcc9f1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Loading/index.vue
// module id = OJkd
// module chunks = 1